module.exports = __webpack_public_path__ + "img/Fake_Video-5.aa2ae532.jpg";